export const GENERATE_PATIENT_REPORT_MODAL_TITLE = 'Generate patient report';
export const GENERATE_PATIENT_REPORT_MODAL_DESCRIPTION =
  "This workflow will generate a PDF that will automatically be saved to the patient's Documents tab.";
export const GENERATE_PATIENT_REPORT_REPORT_TYPE_LABEL = 'Report type';
export const GENERATE_PATIENT_REPORT_ISSUES_TITLE =
  'Review potential data issues';
export const GENERATE_PATIENT_REPORT_ISSUES_DESCRIPTION =
  'The following data are either missing from the patient chart or potentially inaccurate. Please review before generating the patient report.';
export const GENERATE_PATIENT_REPORT_CANCEL_CTA = 'Cancel';
export const GENERATE_PATIENT_REPORT_CREATE_CTA = 'Create report';
export const GENERATE_PATIENT_REPORT_PROCEED_CTA = 'Proceed with creating report';

type PatientReportIssueCopy = { label: string; detail: string };
export const PATIENT_REPORT_ISSUE_COPY: Record<string, PatientReportIssueCopy> = {
  MISSING_WEIGHT: { label: 'Patient weight', detail: 'Missing from chart' },
  MISSING_HEIGHT: { label: 'Patient height', detail: 'Missing from chart' },
  MISSING_TARGET_WEIGHT_RANGE: {
    label: 'Target weight range',
    detail: 'Missing from chart',
  },
  MISSING_MEDICATIONS: { label: 'Medications', detail: 'Missing from chart' },
  ABNORMAL_WEIGHT_CHANGE: {
    label: 'Patient weight',
    detail: 'Variation since last month',
  },
};
